// extracted by mini-css-extract-plugin
export var skillsContainer = "SkillsList-module--skillsContainer--2sfj3";
export var heading = "SkillsList-module--heading--3zeIX";